import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";
const HistoryUsedCardPopup = ({
  open,
  handleClose,
  handleChangeFormSearch,
  pageHistoryUsedCard,
  searchHistoryUsedCard,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Lịch sử sử dụng thẻ`}
      formik={{
        initialValues: {},

        onSubmit: handleChangeFormSearch,
        enableReinitialize: true,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              pageHistoryUsedCard={pageHistoryUsedCard}
              searchHistoryUsedCard={searchHistoryUsedCard}
              handleChangeFormSearch={handleChangeFormSearch}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ pageHistoryUsedCard, searchHistoryUsedCard, handleChangeFormSearch }) => {
    const { setFieldValue, values } = useFormikContext();
    const { t } = useTranslation();

    return (
      <>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TableComponent
              showOrdinalNumbers
              titleNodata={t("noData")}
              data={pageHistoryUsedCard?.content || []}
              // minWidth={"820px"}
              columns={[
                {
                  field: "clientCard.code",
                  title: t("Ngày giao dịch"),
                  render: (val) => {
                    return <div>{getDateTime(val?.transationDate)}</div>;
                  },
                },
                {
                  field: "department.name",
                  title: t("Cơ sở giao dịch"),
                },
                {
                  field: "price",
                  title: "Người giao dịch",
                  align: "right",
                  render: (val) => (
                    <span>{val?.transactionStaff?.staffName}</span>
                  ),
                },
                {
                  field: "quantity",
                  title: t("Nội dung giao dịch"),
                  render: (data) => {
                    return <span>{data?.invoiceItem?.invoiceItemName}</span>;
                  },
                },

                {
                  field: "practitioner.staffName",
                  title: t("Số tiền giao dịch"),
                  align: "right",
                  render: (data) => {
                    const isIncome = data?.transactionType === 1;
                    const isOutcome = data?.transactionType === -1;

                    const amountColor = isIncome
                      ? "green"
                      : isOutcome
                      ? "red"
                      : "inherit"; 

                    const prefix = isIncome ? "+" : isOutcome ? "-" : "";

                    return (
                      <span style={{ color: amountColor, fontWeight: 600 }}>
                        {prefix}
                        {formatMoney(data?.amount)}
                      </span>
                    );
                  },
                }
              ]}
              dataPagination={{
                pageIndex: searchHistoryUsedCard?.pageIndex,
                pageSize: searchHistoryUsedCard?.pageSize,
                totalElements: pageHistoryUsedCard?.totalElements,
                totalPages: pageHistoryUsedCard?.totalPages,
                setPageIndex: (pageIndex) =>
                  handleChangeFormSearch({ pageIndex }),
                setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  }
);

export default memo(HistoryUsedCardPopup);
